<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Users</ion-title>
        <!-- @if (!vb.disabled) {
        <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
        } -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        {{usersDefinedStr}}
    </ion-list-header>

    <ion-list class="ion-padding" data-test="users">
        @for (user of users; track $index) {
        <ion-item-sliding>
            <ion-item detail="true" data-test="user" (click)="onUserClick(user.uid)" href="javascript:;">
                <ion-label>
                    <span class="line1">{{user.firstName}} {{user.lastName}}</span><br />
                    <span class="line2">{{getRoleTitle(user.role)}}</span>
                </ion-label>
            </ion-item>
            <ion-item-options>
                <ion-button id="deleteUser" color="danger" (click)="confirmDeleteUser(user)" data-test="deleteUser">
                    <ion-icon name="trash"></ion-icon>
                    Delete<br />User
                </ion-button>
            </ion-item-options>
        </ion-item-sliding>
        }
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Add" data-test="addUserBtn" (click)="onAddUserClick()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>